import React from 'react';
import ConfirmationDialog from './ConfirmationDialog';

// CP-5545: the in-app replacement for window.confirm(), whose browser-drawn [OK] [Cancel] can't follow the
// dashboard's button rules (Rea's "Delete Access prompt", 10/16).
//
//   const [confirm, confirmDialog] = useConfirmDialog();
//   ...
//   if (await confirm({ body: `Delete ${name}?` })) { ... }
//   ...
//   return <>{confirmDialog} ...</>;
//
// The OK defaults to "Delete", which ConfirmationDialog renders as the shared DELETE (outlined red + trash);
// pass okButtonText for anything else, and `destructive` for a delete labelled otherwise ("Remove").
export default function useConfirmDialog() {
    const [request, setRequest] = React.useState(null);
    const [open, setOpen] = React.useState(false);

    const confirm = React.useCallback(
        (options = {}) =>
            new Promise((resolve) => {
                setRequest({ ...options, resolve });
                setOpen(true);
            }),
        [],
    );

    // The request stays in state after closing so the dialog keeps its text while it fades out.
    const settle = (result) => {
        setOpen(false);
        request && request.resolve(result);
    };

    const dialog = request ? (
        <ConfirmationDialog
            open={open}
            standardActions
            title={request.title || 'Please confirm'}
            okButtonText={request.okButtonText || 'Delete'}
            cancelButtonText={request.cancelButtonText || 'Cancel'}
            destructive={request.destructive}
            onConfirm={() => settle(true)}
            onCancel={() => settle(false)}
        >
            {request.body}
        </ConfirmationDialog>
    ) : null;

    return [confirm, dialog];
}
